import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ServiceMain from "./ServiceMain";
import Footer from "../../components/Footer";

const Service = () => {
  return (
    <>
      <HeaderFour />

      <ServiceMain />

      <Footer />
    </>
  );
};

export default Service;
